// extracted by mini-css-extract-plugin
export default {"footerBg":"za-z","footerTopLinks":"Aa-z","footerFeedback":"Ba-z","footerSocial":"Ca-z","footerLegalLinks":"Da-z","footerIconCards":"Ea-z","footerBotCopy":"Fa-z"};